<template>
  <teleport to=".main-wrapper">
    <FadeTransition duration="150" appear>
      <div
        v-show="isOpen"
        key="modal-wrapper"
        class="modal-wrapper"
        :class="{ blur }"
        :style="{ backgroundColor: `rgba(0,0,0,${backgroundOpacity})` }"
      >
        <div
          v-if="!hideCloseIcon"
          class="modal-wrapper__close-icon i-close-white"
          @click="closeModal"
        ></div>
        <slot :close="closeModal"></slot>
      </div>
    </FadeTransition>
  </teleport>
</template>

<script>
import FadeTransition from "@/components/shared/transitions/FadeTransition";
import useModalNav from "@/composables/useModalNavigation";

export default {
  components: {
    FadeTransition,
  },
  name: "ModalWindow",
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    hideCloseIcon: {
      type: Boolean,
      default: false,
    },
    blur: {
      type: Boolean,
      default: false,
    },
    backgroundOpacity: {
      type: Number,
      default: 0.8,
    },
  },
  setup(props, { emit }) {
    return useModalNav(props, emit);
  },
};
</script>

<style lang="scss" scoped>
.modal-wrapper {
  position: fixed;
  width: 100vw;
  height: 100vh;
  z-index: 100;
  left: 0;
  top: 0;
  overflow: hidden;

  &.blur {
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
  }

  &__close-icon {
    position: absolute;
    top: 30px;
    left: 30px;
    z-index: inherit;
  }
}
</style>
